export const deleteAccess = (payload: any) => ({
    type: "@saga/DELETE_ACCESS",
    payload
});